export default __webpack_public_path__ + "static/media/slider1.dbd348c3.jpeg";